import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Buffer } from "buffer";
//var Buffer = require('buffer/').Buffer  // note: the trailing slash is important!
import { GetenvironmentService } from "./getenvironment.service";

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  constructor(private httpClient: HttpClient,
    private getEnv: GetenvironmentService) {

    this.environment = getEnv.currentEnvironment == 'Stage' ? 'Stage' : 'Production'
  }
  //CHANGE ALSO IN getenvironment.service.ts
  environment: string = "Production";//Stage,Production
  autoId;
  token;

  apiUrl = {
    "Local": {
      "url": "http://localhost:3026/",
      "webSocketUrl": "https://agoranodeapp.azurewebsites.net/",
      "storageConfig": {
        "accessKey": "atom361dev",//"tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
        "region": 14,
        "bucket": "agoravideo",
        "secretKey": "tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
        "vendor": 5,
      }
    },
    "Production": {
      // "url": "https://vcpvnodeapp.azurewebsites.net/",
      // "webSocketUrl": "https://vcpvnodeapp.azurewebsites.net/",
      "url": "https://v.atom361.co.in/",
      "webSocketUrl": "https://v.atom361.co.in/",
      "storageConfig": {
        "accessKey": "atom361prod",
        "region": 14,
        "bucket": "agoravideo",
        "secretKey": "JQoVfRO1bH4HwDg68E/nsk+XpnQzZezlQa1/YiPmJNWbOBaw/4uBzUPgoU4ZBdxuCSriagybDZ1+JacSRQeBrg==",
        "vendor": 5,
      }
    },
    "Stage": {
      // "url": "https://agoranodeapp.azurewebsites.net/",
      "url": "https://v.atom361.co.in/",
      "webSocketUrl": "https://v.atom361.co.in/",
      // "webSocketUrl": "https://agoranodeapp.azurewebsites.net/",
      // "storageConfig": {
      //   "accessKey": "atom361prod",
      //   "region": 14,
      //   "bucket": "agoravideo",
      //   "secretKey": "JQoVfRO1bH4HwDg68E/nsk+XpnQzZezlQa1/YiPmJNWbOBaw/4uBzUPgoU4ZBdxuCSriagybDZ1+JacSRQeBrg==",
      //   "vendor": 5,
      // }
      "storageConfig": {
        "accessKey": "atom361dev",
        "region": 14,
        "bucket": "agoravideo",
        "secretKey": "tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
        "vendor": 5,
      }
    }
  }

  postMethod(apiName: string, body: any) {
    return this.httpClient.post(this.apiUrl[this.environment]["url"] + apiName, body);
  }

  getMethod(apiName: string, patams: any) {
    return this.httpClient.get(this.apiUrl[this.environment]["url"] + apiName, { params: patams });
  }
  getMethodForAWS(apiName: string, patams: any) {
    return this.httpClient.get(this.apiUrl[this.environment]["url"] + apiName, { params: patams, responseType: "blob" });
  }

  postAgoraMethod(apiName: string, body: any) {
    let headerObj = new HttpHeaders();

    const plainCredential = "08d6215e9e97444a8b20a67a467ea0ca" + ":" + "80e69616e58540298edeb123fe0cc683"

    const encodedCredential = Buffer.from(plainCredential).toString('base64');
    const authorizationField = "Basic " + encodedCredential
    headerObj = headerObj.append("Authorization", authorizationField);
    headerObj = headerObj.append("Content-Type", 'application/json');

    // console.log("Body = ", JSON.stringify(body));

    return this.httpClient.post(apiName, JSON.stringify(body), { headers: headerObj });
  }


  getQueryAPI(apiName) {
    let headerObj = new HttpHeaders();

    const plainCredential = "08d6215e9e97444a8b20a67a467ea0ca" + ":" + "80e69616e58540298edeb123fe0cc683"

    const encodedCredential = Buffer.from(plainCredential).toString('base64');
    const authorizationField = "Basic " + encodedCredential
    headerObj = headerObj.append("Authorization", authorizationField);
    headerObj = headerObj.append("Content-Type", 'application/json');

    // console.log("Body = ", JSON.stringify(body));

    return this.httpClient.get(apiName, { headers: headerObj });
  }


}
